<template>
  <div id="app">
    <transition
      name="page-transition"
      mode="out-in"
      @after-leave="$root.$emit('scrolltotop')">
      <router-view />
    </transition>
    <app-footer />
  </div>
</template>

<script>
import Footer from './components/Footer/Footer.vue';

export default {
  name: 'app-root',
  metaInfo: {
    // if no subcomponents specify a metaInfo.title, this title will be used
    title: 'Observatório do Câncer RS',
  },
  components: {
    'app-footer': Footer,
  },
};
</script>

<style lang="scss">
html {
  scroll-behavior: smooth;
}

.page-transition-enter-active,
.page-transition-leave-active {
  transition: opacity 300ms;
}

.page-transition-enter,
.page-transition-leave-to {
  opacity: 0;
}

.page-transition-enter-to,
.page-transition-leave {
  opacity: 1;
}
</style>
